import React, { useState, useEffect } from "react";
import { Form, Upload, Image } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./UploadFormItem.css";
import { FiTrash } from "react-icons/fi";

/**
 * UploadFormItem is a reusable component for uploading files.
 *
 * @param {string} name - The name of the form item.
 * @param {string} label - The label to display above the upload button.
 * @param {string} requiredMessage - The message to display if no file is uploaded.
 * @param {string} greyText - The text to display below the label.
 * @param {function} onFileChange - A callback function to notify the parent component when a file is uploaded or removed.
 */

const UploadFormItem = ({
  name,
  label,
  requiredMessage,
  greyText,
  onFileChange,
  externalURL,
}) => {
  const [imageFile, setImageFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);

  useEffect(() => {
    onFileChange(imageFile, previewURL);
  }, [imageFile, previewURL]);

  useEffect(() => {
    if (externalURL) {
      setPreviewURL(externalURL);
    }
  }, [externalURL]);

  const handleUpload = (file) => {
    setImageFile(file);
    setPreviewURL(URL.createObjectURL(file));
    return false;
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    setImageFile(null);
    setPreviewURL(null);
    onFileChange(null, null);
  };

  return (
    <div className="custom-form-item">
      <Form.Item
        label={
          <span>
            <div>{label}</div>
            <div style={{ color: "#828282", fontSize: 10 }}>{greyText}</div>
          </span>
        }
        name={name}
        valuePropName="file"
        getValueFromEvent={() => imageFile}
        initialValue={externalURL}
        rules={[
          {
            validator: (_, value) => {
              if (!imageFile && !previewURL) {
                return Promise.reject(new Error(requiredMessage));
              }
              return Promise.resolve();
            },
          },
        ]}
        style={{ width: "100%" }}
      >
        <Upload
          listType="picture-card"
          showUploadList={false}
          beforeUpload={handleUpload}
          className="upload-form-item"
        >
          {previewURL ? (
            <div className="image-container">
              <FiTrash className="delete-icon" onClick={handleDelete} />
              <Image preview={false} height={90} src={previewURL} />
            </div>
          ) : (
            <div>
              <PlusOutlined style={{ color: "#03B0F7" }} />
              <div style={{ color: "#00000073", fontSize: 16 }}>Upload</div>
            </div>
          )}
        </Upload>
      </Form.Item>
    </div>
  );
};

export default UploadFormItem;
